import { NotificationComponent } from './notification/notification.component';
import { NotificationService } from './_services/notification.service';
import { MessagingService } from './_services/messaging.service';
import { Routes, RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MyErrorHandler } from './_classes/error-handler';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbButtonLabel } from '@ng-bootstrap/ng-bootstrap/buttons/buttons.module';
import { AngularFireModule } from 'angularfire2';
import { config } from '../environments/firebase.config';
import { AngularFireDatabase } from 'angularfire2/database-deprecated';
import { AngularFireAuth } from 'angularfire2/auth';
import { HttpModule, Http } from '@angular/http';
import { TranslateModule, TranslateLoader, TranslateStaticLoader } from 'ng2-translate';
import { PagesModule } from './pages/pages.module';
import { PagesComponent } from './pages/pages.component';
import { AuthenticationService } from './_services/authentication.service';
import * as firebase from 'firebase';
import { AuthGuard } from './_guards/auth.guard';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MessagesComponent } from './messages/messages.component';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { MomentModule } from 'angular2-moment';
import { MessagesNotificationComponent } from './messages-notification/messages-notification.component';
import { ProfileUpdateComponent } from './profile-update/profile-update.component';
import { ChangePasswordComponent } from './profile-update/change-password/change-password.component';
import { AccountSettingsComponent } from './profile-update/account-settings/account-settings.component';
import { UserInterestedComponent } from './profile-update/user-interested/user-interested.component';
import { FriendRequestComponent } from './friend-request/friend-request.component';
import { RecentPostsComponent } from './recent-posts/recent-posts.component';
import { PhotoUploadComponent } from './profile-update/photo-upload/photo-upload.component';
import { LoaderService } from './_services/loader.service';
import { WelcomePageComponent } from './welcome-page/welcome-page.component';
import { MasonryModule } from 'angular2-masonry';
import { DownloadImageService } from './_services/download-image.service';
import { SplashScreenService } from './_services/splash-screen.service';
import 'hammerjs';
import { AboutUsComponent } from './about-us/about-us.component';
import { ConfidentialityComponent } from './confidentiality/confidentiality.component';
import { LoaderComponent } from './directive/loader/loader.component';
import { HttpClientModule } from '@angular/common/http';
import { EntitiesComponent } from './pages/entities/entities.component';
import { AlertModule } from './directive/alert/alert.module';
import { AuthModule } from './auth/auth.module';
import { CategoriesComponent } from './welcome-page/categories/categories.component';
import { LastPostsComponent } from './welcome-page/last-posts/last-posts.component';
import { AppComingComponent } from './welcome-page/app-coming/app-coming.component';
import { WelcomeFooterComponent } from './welcome-page/welcome-footer/welcome-footer.component';
import { DialogComponent } from './directive/dialog/dialog.component';
// import * as Raven from 'raven-js';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { BadwordsService } from './_services/badwords.service';
import { environment } from '../environments/environment';
import { ApiService } from './_services/api.service';
import { ScrollService } from './_services/scroll.service';
import { MetaModule } from 'ng2-meta';
import { CategoriesService } from './_services/categories.service';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { WeeklyPostsService } from './_services/weeklyPosts.service';
import { BlogHomeComponent } from './blog-page/home/home.component';
import { BlogPostComponent } from './blog-page/blogPost/blogPost.component';
import { BlogCategoryComponent } from './blog-page/category/category.component';

// Raven
//   .config('https://acb82053685f4e53b225460dfd2e73ea@sentry.io/302868')
//   .install();

export function createTranslateLoader(http: Http) {
  return new TranslateStaticLoader(http, './assets/i18n', '.json');
}
const firebaseConfig = environment.development ? config.development : config.production;
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}
const routes: Routes = [{
  path: 'auth',
  loadChildren: './auth/auth.module#AuthModule'
}, {
  path: ':uniqueName',
  component: EntitiesComponent

}, {
  path: '',
  loadChildren: './pages/pages.module#PagesModule'
}];

@NgModule({
  declarations: [
    AppComponent,
    DialogComponent,
    MessagesComponent,
    BlogHomeComponent,

    BlogCategoryComponent,
    BlogPostComponent,
    NavBarComponent,
    PagesComponent,
    NotificationComponent,
    MessagesNotificationComponent,
    ProfileUpdateComponent,
    ChangePasswordComponent,
    AccountSettingsComponent,
    UserInterestedComponent,
    FriendRequestComponent,
    RecentPostsComponent,
    PhotoUploadComponent,
    WelcomePageComponent,
    AboutUsComponent,
    ConfidentialityComponent,
    LoaderComponent,
    EntitiesComponent,
    CategoriesComponent,
    LastPostsComponent,
    AppComingComponent,
    WelcomeFooterComponent
  ],
  imports: [
    HttpClientModule,
    BrowserModule.withServerTransition({ appId: 'bigAdvice' }),
    AlertModule,
    PagesModule,
    FormsModule,
    ReactiveFormsModule,
    MomentModule,
    MasonryModule,
    AngularFirestoreModule,
    AuthModule,
    BrowserAnimationsModule,
    HttpModule,
    NgbModule.forRoot(),
    DeviceDetectorModule.forRoot(),
    AngularFireModule.initializeApp(firebaseConfig),
    //AngularFirestoreModule.enablePersistence(),
    RouterModule.forRoot(routes),
    MetaModule.forRoot(),
    TranslateModule.forRoot({
      provide: TranslateLoader,
      useFactory: (createTranslateLoader),
      deps: [Http]
    })
  ]
  ,
  providers: [
    LoaderService,
    NgbButtonLabel,
    AngularFireDatabase,
    AuthenticationService,
    NotificationService,
    SplashScreenService,
    AuthGuard,
    MessagingService,
    ApiService,
    BadwordsService,
    DownloadImageService,
    WeeklyPostsService,
    ScrollService,
    CategoriesService,
    { provide: ErrorHandler, useClass: MyErrorHandler },
    AngularFireAuth],
  bootstrap: [AppComponent]

})
export class AppModule { }




// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/app.module.ts